import React from "react";
import "../leftSide.scss";

function ModalListEntry(props) {
  const {
    modelName,
    modelDescription,
    speqqleID,
    // id,
    handleClick,
    // abbreviation,
    // params,
  } = props;
  return (
    <div className="modalListEntry" onClick={() => handleClick(speqqleID)}>
      <div className="modalListEntryName" title={modelDescription}>
        {modelName}
      </div>
    </div>
  );
}

export default ModalListEntry;
